<template>
    <div class="board__column column">
        <div v-click-outside="reset" v-if="isEditing">
            <input @keyup.enter="renameColumn()"
                   maxlength="32"
                   v-model="form.name"
                   ref="input"
                   type="text"
                   class="lc-edit-column-title form__input column__input"
                   :class="{ 'form__input--error' : form.errors.has('name') }"/>
            <p v-if="form.errors.has('name')" class="form__help form__help--error">{{ form.errors.get('name') }}</p>
            <div class="quick-action__controls">
                <button @click.prevent="reset" :disabled="form.busy" class="button button--outline button--small">Cancel</button>
                <button @click.prevent="renameColumn" :disabled="form.busy" class="button button--primary button--small">Rename Column</button>
            </div>
        </div>
        <header v-else class="js-column-handle column__header">
            <h3 class="lc-column-title column__title">{{ column.name }}</h3>
            <more-navigation class="lc-column-options column__options" ref="navigation" orientation="horizontal">
                <li class="dropdown-menu__item">
                    <a href="#" @click.prevent="editColumn()" class="lc-rename-column dropdown-menu__link">Rename column</a>
                </li>
                <li v-if="isEmpty" class="dropdown-menu__item">
                    <a href="#" @click.prevent="deleteColumn()" class="lc-delete-column dropdown-menu__link dropdown-menu__link--danger">Delete column</a>
                </li>
            </more-navigation>
        </header>
        <draggable v-model="jobs"
                   group="jobs"
                   ghost-class="card--ghost"
                   :disabled="isMobile"
                   @start="startDragging"
                   @end="stoppedDragging"
                   @change="onJobDragged"
                   class="column__cards">
            <card :job="job" v-for="job in jobs" :key="job.id" class="lc-job-item" />
        </draggable>
        <quick-create-job :column="column"></quick-create-job>
    </div>
</template>

<script>
import Draggable from 'vuedraggable'
import Card from './Card'
import QuickCreateJob from './QuickCreateJob'
import MoreNavigation from '../Global/MoreNavigation'
import Device from '../../mixins/deviceAware'
import calculatePosition from './../../mixins/calculatePosition'
import Form from '../../helpers/Form'
import { mapGetters } from 'vuex'

export default {
    mixins: [calculatePosition, Device],

    props: {
        column: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            isEditing: false,
            form: new Form({
                name: this.column.name
            })
        }
    },

    methods: {
        editColumn () {
            this.isEditing = true
            this.closeNavigation()

            this.$nextTick(() => {
                this.$refs.input.focus()
            })
        },

        closeNavigation () {
            this.$refs.navigation.close()
        },

        reset () {
            this.isEditing = false
            this.form.name = this.column.name
            this.form.errors.forget()
        },

        renameColumn () {
            let data = {
                column: this.column,
                form: this.form
            }

            this.$store.dispatch('channel/renameColumn', data).then(() => {
                this.reset()
            })
        },

        deleteColumn () {
            this.$store.dispatch('channel/deleteColumn', this.column)
        },

        startDragging (event) {
            this.$emit('start-dragging')
        },

        stoppedDragging () {
            this.$emit('stopped-dragging')
        },

        onJobDragged ({ moved, added, removed }) {
            if (removed) {
                return
            }

            let job = added ? added.element : moved.element
            let position = added
                ? this.calculatePositionWhenAdded(this.jobs, added.newIndex)
                : this.calculatePositionWhenMoved(this.jobs, moved.newIndex, moved.oldIndex)

            let data = {
                id: job.id,
                column_id: this.column.id,
                position
            }

            this.$store.dispatch('channel/repositionJob', data).then((response) => {
                if (response.data.position < 1 || response.data.position > 1000000) {
                    this.$store.dispatch('channel/repositionAllJobs', this.jobs)
                }
            })
        }
    },

    computed: {
        ...mapGetters('channel', {
            channelJobs: 'jobs'
        }),

        jobs: {
            set (jobs) {
                // Do something?
            },

            get () {
                return this.channelJobs(this.column.id)
            }
        },

        isEmpty () {
            return this.jobs.length === 0
        }
    },

    components: {
        Card,
        Draggable,
        MoreNavigation,
        QuickCreateJob
    }
}
</script>
